import { render } from "./ScheduleDetailsSetupTable.vue?vue&type=template&id=2df383e0&scoped=true"
import script from "./ScheduleDetailsSetupTable.vue?vue&type=script&lang=js"
export * from "./ScheduleDetailsSetupTable.vue?vue&type=script&lang=js"

import "./ScheduleDetailsSetupTable.vue?vue&type=style&index=0&id=2df383e0&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df383e0"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QList,QItem,QItemSection,QItemLabel,QTable,QBtn});qInstall(script, 'directives', {ClosePopup});
